import { Component, OnInit, Input } from '@angular/core';
import { Message, MessageService, MessageSeverity } from '../../services/message.service';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss']
})
export class MessagesComponent implements OnInit {

  @Input() id: string;

  messages: Message[] = [];

  constructor(private messageService: MessageService) { }

  ngOnInit() {
    this.messageService.getMessage(this.id).subscribe((message: Message) => {
      if (!message.message) {
        // clear messages when an empty message is received
        this.messages = [];
        return;
      }

      // add message to array
      this.messages.push(message);
    });
  }

  removeMessage(message: Message) {
    this.messages = this.messages.filter(x => x !== message);
  }

  toBootstrapSeverity(message: Message) {
    if (message.severity === MessageSeverity.ERROR) {
      return 'danger';
    }
    if (message.severity === MessageSeverity.WARNING) {
      return 'warning';
    }
    if (message.severity === MessageSeverity.SUCCESS) {
      return 'success';
    }
    return 'info';
  }
}
